<template>
 
<div class="nav_row_tabs nav_tabs__navbar" >

  <b-navbar toggleable="xl" type="dark" class="navmenu" id="navbar_menu wat_pro" v-model="getdesigndetail">
    
    <!-- Design Details Code -->
    <router-link :to="'/design_details/' + route_id" v-bind:class="design_tab_class" v-if="component_name=='design_details'" style="background-color: #F8F8FF">
    <div> 
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <!-- <div class="nav_tabs__tab-block" style="width: 100px;"><span class="title" id="activeTitle">Design Details</span><span class="sub_title completed">Completed</span></div> -->
          <div class="nav_tabs__tab-block" style="width:60px;"><span class="title" id="activeTitle">Techpack Details</span></div>
          
      </div>    
    </div>
  </router-link>
  <router-link :to="'/design_details/' + route_id" v-else class="nav_tabs">
    <div>    
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon"></div>
          <!-- <div class="nav_tabs__tab-block" style="width: 100px;"><span class="title" id="activeTitle">Design Details</span><span class="sub_title completed">Completed</span></div> -->
          <div class="nav_tabs__tab-block" style="width: 60px;"><span class="title" id="activeTitle">Techpack Details</span></div>
      </div>   
    </div>
  </router-link>
  <!-- Design Details Ends -->
<!-- {{ user_type }} -->
  <!-- File Code  -->
  
  <router-link :to="'/design_files/' + route_id" v-bind:class="design_tab_class" v-if="component_name=='design_files' && user_type!= 'PO Executive' " style="background-color: #F8F8FF">
    <div>
      <div id="file_tab_show" class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image">
          
        <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block"  style="width:60px;"><span class="title" >Files</span><span class="sub_title completed">Uploaded</span></div>
      </div>
       
    </div>
  </router-link> 
  <!-- this.style_details.buyer_grade -->
  <router-link :to="'/design_files/' + route_id" v-else-if="(file_tab_status == true  && user_type!= 'PO Executive') || (user_type=='Buyer' && (style_details.operational_status == 'Buying_Head-approved' || style_details.operational_status == 'FH-approved'))  " class="nav_tabs" >  
  	<div >
  	      <div id="file_tab_show" class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
  	          <div class="nav_tabs__tab-image">
  	          <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon"></div>
  	          <div class="nav_tabs__tab-block"  style="width:60px;"><span class="title" >Files</span><span class="sub_title completed">Uploaded</span></div>
  	      </div>      
  	</div>
  </router-link>

<!-- File disable Else Part -->
  <div class="nav_tabs nav_tabs__tab--disabled" v-else>
    <div v-if="user_type!= 'PO Executive'">
    <div id="file_tab_hidden" class="nav_tabs__tab flex nav_tabs__tab--disabled " data-tip="" data-class="dark-tooltip" currentitem="false" >
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div></div>
        <div class="nav_tabs__tab-block"><span class="title" >Files</span><span class="sub_title completed">Uploaded</span></div>
      </div>
  </div>
  <!-- File disbale Else Part Ends-->
  <!-- File Code Ends -->

  <!-- Quotes Code -->
  <router-link :to="'/design_quotes/' + route_id" v-bind:class="design_tab_class" v-if="(component_name=='design_quotes' || component_name=='requested_quotation') && user_type != 'Fit_Technician'  && user_type!= 'PO Executive'" style="background-color: #F8F8FF">
    <div  >
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block" ><span class="title" id="activeTitle">Quote</span><span class="sub_title completed"></span></div>
      </div>
    </div>
  </router-link>

  <router-link :to="'/design_quotes/' + route_id" v-else-if="(quote_tab_status== true || files == 1) && user_type != 'Fit_Technician'  && user_type!= 'PO Executive'" class="nav_tabs">
    <div>
          <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image">
            <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon">
          </div><span class="title" >Quote</span><span class="sub_title completed"></span>
        </div>
    </div>
  </router-link>

  <!-- Quotes Disable Else Part -->
  <div class="nav_tabs nav_tabs__tab--disabled" v-else>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false"  v-if="user_type != 'Fit_Technician' && user_type!= 'PO Executive'">
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div>
        <span class="title" >Quote</span><span class="sub_title completed"></span>
      </div>
  </div>
  <!-- Quotes disable Else Part Ends -->
  <!-- Quotes Code Ends -->


    <!-- Code For Sampling -->
    <router-link :to="'/design_samples/' + route_id" v-bind:class="design_tab_class" v-if="component_name=='design_samples' && user_type!= 'PO Executive'" style="background-color: #F8F8FF">
      <div  >
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
            <div class="nav_tabs__tab-image"> 
            <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
            <div class="nav_tabs__tab-block" ><span class="title" id="activeTitle">Sampling</span><span class="sub_title completed"></span></div>
        </div>
      </div>
    </router-link>
    <router-link :to="'/design_samples/' + route_id" class="nav_tabs" v-else-if="(sample_tab_status== true || sampleCode == 17) && user_type!= 'PO Executive' ">
      <div >
          <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image">
            <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon">
          </div>
          <span class="title" >Sampling</span>
        </div>
      </div>
    </router-link>

  <!-- Sampling Disable Else Part -->
  <div class="nav_tabs nav_tabs__tab--disabled" v-else>
    <div v-if="user_type!= 'PO Executive'">
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div>
        <span class="title" >Sampling</span><span class="sub_title completed"></span>
      </div>
    </div>
  </div>
  <!-- Sampling Disable Else Part Ends -->
  <!-- Sampling Code Ends -->

    <!-- TNA tab starts here -->

  <router-link :to="'/design_po_tna/' + route_id" v-bind:class="design_tab_class" v-if="component_name=='design_po_tna' && user_type!='Fit_Technician' && user_type!= 'PO Executive'" style="background-color: #F8F8FF;width:84px">
    <div>
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block" ><span class="title" id="activeTitle">TNA</span><span class="sub_title completed"></span></div>
      </div>
    </div>
  </router-link>
  <router-link :to="'/design_po_tna/' + route_id" class="nav_tabs" v-else-if="(tna_tab_status== true && user_type!='Fit_Technician' && user_type!= 'PO Executive') || tnacode == 23" style="width:84px">
    <div>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="nav_tabs__tab-image">
          <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon">
        </div>
        <span class="title" >TNA</span>
      </div> 
    </div>
  </router-link>

  <!-- TNA Else Part -->

  <div class="nav_tabs nav_tabs__tab--disabled" style="width:84px" v-else>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false"  v-if="user_type != 'Fit_Technician' && user_type!= 'PO Executive'">
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div>
        <span class="title" >TNA</span><span class="sub_title completed"></span>
      </div>
  </div>
  <!-- TNA Else Part Ends -->

  <!-- PO tab starts here -->

  <router-link :to="'/design_purchaseorder/' + route_id" v-bind:class="design_tab_class" v-if="component_name=='design_purchaseorder' && user_type != 'Fit_Technician'" style="background-color: #F8F8FF;width:84px">
    <div>
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block" ><span class="title" id="activeTitle">PO</span><span class="sub_title completed"></span></div>
      </div>
    </div>
  </router-link>
  <router-link :to="'/design_purchaseorder/' + route_id" class="nav_tabs" v-else-if="(po_tab_status== true && user_type != 'Fit_Technician') || pocode == 23" style="width:84px">
    <div>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="nav_tabs__tab-image">
          <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon">
        </div>
        <span class="title" >PO</span>
      </div> 
    </div>
  </router-link>

  <!-- PO Else Part -->
  <div class="nav_tabs nav_tabs__tab--disabled" style="width:84px" v-else>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false"  v-if="user_type != 'Fit_Technician'">
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div>
        <span class="title" >PO</span><span class="sub_title completed"></span>
      </div>
  </div>
  <!-- PO Else Part Ends -->

 <!-- Inspection code starts  -->
   <router-link :to="'/qc_inspection/' + route_id" v-bind:class="design_tab_class" v-if="component_name=='qc_inspection' && user_type!='Fit_Technician' && user_type!='Quality_Controller' && user_type!= 'PO Executive'" style="background-color: #F8F8FF;width:100%;">
    <div>
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block" ><span class="title" id="activeTitle">Inspection</span><span class="sub_title completed"></span></div>
      </div>
    </div>
  </router-link>
  <router-link :to="'/qc_inspection/' + route_id" class="nav_tabs" v-else-if="(inspection_tab_status== true && user_type!='Fit_Technician' && user_type!= 'PO Executive') || inspcode == 25" style="width:100%">
    <div>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="nav_tabs__tab-image">
          <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon">
        </div>
        <span class="title" >Inspection</span>
      </div> 
    </div>
  </router-link>

  <!-- Inspection Else Part -->
  <div class="nav_tabs nav_tabs__tab--disabled" style="width:84px" v-else>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false"  v-if="user_type != 'Fit_Technician' && user_type!= 'PO Executive'">
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div>
        <span class="title" >Inspection</span><span class="sub_title completed"></span>
      </div>
  </div>
  <!-- Inspection Else Part Ends -->
&nbsp;



<!-- Message Tab -->
<!-- v-if="component_name=='style_message' && message_tab_status== true" -->
 <!--    <router-link :to="'/style_message/' + route_id" v-bind:class="design_tab_class"  style="background-color: #D3D3D3" v-if="user_type!='Fit_Technician' && component_name=='style_message' &&  message_tab_status== true" >
    <div> 
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block"><span class="title" id="activeTitle">Message</span><span class="sub_title completed"></span></div>
      </div>    
    </div>
  </router-link> -->
      <router-link :to="'/style_message/' + route_id" v-bind:class="design_tab_class" id="messagetab"  style="background-color: #D3D3D3;width:100%; " v-if="user_type!='Fit_Technician' && component_name=='style_message' &&  message_tab_status== true && user_type!= 'PO Executive'" >
      <div  >
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip"  currentitem="false">
            <div class="nav_tabs__tab-image"> 
            <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
            <div class="nav_tabs__tab-block" ><span class="title" id="activeTitle">Message</span><span class="sub_title completed"></span></div>
        </div>
      </div>
    </router-link>
  <router-link :to="'/style_message/' + route_id" id="messagetab" class="nav_tabs" style="width:100px" v-else-if="message_tab_status== true && user_type!='Fit_Technician' && user_type!= 'PO Executive'">
    <div>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="nav_tabs__tab-image">
          <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon">
        </div>
        <span class="title" >Message</span>
      </div> 
    </div>
  </router-link>

  <!-- msg Else Part -->
  <div class="nav_tabs nav_tabs__tab--disabled" id="messagetab" style="width:100px" v-else>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false"  v-if="user_type != 'Fit_Technician' && user_type!= 'PO Executive'">
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div>
        <span class="title" >Message</span><span class="sub_title completed"></span>
      </div>
  </div>
  <!-- <router-link :to="'/style_message/' + route_id" v-else-if="message_tab_status== true" class="nav_tabs" style="background-color: #D3D3D3">
    <div>    
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-orange-clock.2d90a802.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block"><span class="title" id="activeTitle">Message</span><span class="sub_title completed"></span></div>
      </div>   
    </div>
  </router-link>
   <div class="nav_tabs nav_tabs__tab--disabled" v-else>
        <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
        <div class="nav_tabs__tab-image">
        <img src="../assets/images/ic-grey-check.87351b3c.png" alt="progress icon"></div>
        <span class="title" >Message</span><span class="sub_title completed"></span>
      </div>
  </div> -->
  <!-- Message Tab Ends -->
</b-navbar>
<!-- <div id='navbarMenu'>
       {{files}}
      {{sampleCode}}
      {{pocode}}
    </div> -->
</div>
   
</template>
<script>

	import CONSTANTS from '@/utils/constants'
	import auth from '@/utils/auth'
	import Vue from 'vue'

	const axios = require('axios')

	export default {
    name:"child",
    props:["files","sampleCode","pocode",'tnacode',"inspcode"],
	 data () {
    
	 	return {
	 	  user_type: '',
	 	  style_details:[],	
	 	  route_id: '',
	 	  result:[],
	 	  temp_color: '',
	 	  temp_sizeset : 0,
	 	  temp_style_description:'',
	 	  temp_style_name: '',
	 	  fileObj_msg: '',
	 	  totalRows: 0,
	 	  tp_status: false,   
      measurementchart_status: false,
      bom_status: false,
      fileupload_status: false,
      status_code_number: 0,
      file_tab_status: false,
      quote_tab_status: false,
		  sample_tab_status: false,
      message_tab_status: false,
      inspection_tab_status:false,
		  po_tab_status: false,
      tna_tab_status: false,
		  DesignDetails_tab_status: false,
		  design_tab_class: '',
		  name:"auth",
		  code: 0,
		  design_details_tab: 0,
		  component_name: '',
      all_files_uploaded: 0,
	 	}
	 },
	 
	 created: function() { 
    var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)
        
	 	this.getdesigndetail();
	 	 this.route_id=this.$route.params.id; 
     var userData = localStorage.getItem('userData');
     var userInfo = JSON.parse(userData);
     this.user_type= userInfo[0].user_type;
	 	 this.design_tab_class= "nav_tabs is-tab-selected"
    //  window.onscroll = function() {stickyFunction()};

    // var navbar = document.getElementById("navbar_menu");
    // var sticky = navbar.offsetTop;

    
	 },

	 mounted() {
  	var str = window.location.pathname
        var res = str.split("/");
        this.component_name = res[1];
  },
  watch:{
           getdesigndetail: function () {
        // alert("From File");
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,   
                //style_id : 327           
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
             
            this.style_details  = this.result.returnvalue[0];
            this.all_files_uploaded = this.result.returnvalue[0].all_files_uploaded;
            this.temp_color=this.style_details.color; 
            this.temp_sizeset=this.style_details.no_of_sizeset;
            this.temp_style_description=this.style_details.style_description;
            this.temp_style_name = this.style_details.style_name;
            this.fileObj_msg = this.result.returnvalue[1].file_name;
            this.totalRows = this.result.returnvalue.length;
            this.code = this.style_details.status_code_number;
         
            
        if(this.code<=8){
          this.design_details_tab= 1
        }
            for(var i=0;i<=this.totalRows;i++){
              if(this.style_details.status_code_number<=8){
                this.DesignDetails_tab_status =true; 
                //this.message_tab_status = true;
              } 
              if(this.style_details.status_code_number>=8 && (this.style_details.status_code_number!=9 && this.style_details.status_code_number!=10)){

                this.file_tab_status =true; 
              }
              if(this.style_details.all_files_uploaded==1){
                this.quote_tab_status =true;
              }
              if(this.style_details.status_code_number>=15){ 
                this.message_tab_status = true;
                
              } 
              if(this.style_details.status_code_number >= 17 && (this.style_details.status_code_number!=18 && this.style_details.status_code_number!=19)){
                this.sample_tab_status =true;
              }
              if(this.style_details.status_code_number>=23 && this.style_details.status_code_number!=24){
                this.po_tab_status = true;
                this.tna_tab_status = true;
                
              }
             
              if (this.style_details.status_code_number>=25)
              {
                this.inspection_tab_status = true;
              }

            }

            if(this.result.returnvalue[1].file_name=='Please upload Techpack,Measurement Chart and BOM files'){
            }
      
            
            this.totalRows = this.result.returnvalue.length;                
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
        
   
   
       },
        
  },
	 methods: { 
   
	 	/****** Function to design details ********/
       getdesigndetail: function () {
        // alert("From File");
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,   
                //style_id : 327           
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
             
            this.style_details  = this.result.returnvalue[0];
            this.all_files_uploaded = this.result.returnvalue[0].all_files_uploaded;
            this.temp_color=this.style_details.color; 
            this.temp_sizeset=this.style_details.no_of_sizeset;
            this.temp_style_description=this.style_details.style_description;
            this.temp_style_name = this.style_details.style_name;
            this.fileObj_msg = this.result.returnvalue[1].file_name;
            this.totalRows = this.result.returnvalue.length;
            this.code = this.style_details.status_code_number;
         
            
    		if(this.code<=8){
    			this.design_details_tab= 1
    		}
            for(var i=0;i<=this.totalRows;i++){
            	if(this.style_details.status_code_number<=8){
                this.DesignDetails_tab_status =true; 
                //this.message_tab_status = true;
              } 
              if(this.style_details.status_code_number>=8 && (this.style_details.status_code_number!=9 && this.style_details.status_code_number!=10)){

                this.file_tab_status =true; 
              }
              if(this.style_details.all_files_uploaded==1){
              	this.quote_tab_status =true;
              }
              if(this.style_details.status_code_number>=15){ 
                this.message_tab_status = true;
                
              } 
              if(this.style_details.status_code_number >= 17 && (this.style_details.status_code_number!=18 && this.style_details.status_code_number!=19)){
              	this.sample_tab_status =true;
              }
              if(this.style_details.status_code_number>=23 && this.style_details.status_code_number!=24){
                this.po_tab_status = true;
                this.tna_tab_status = true;
                
              }
              if (this.style_details.status_code_number>=25)
              {
                this.inspection_tab_status = true;
              }

            }

            if(this.result.returnvalue[1].file_name=='Please upload Techpack,Measurement Chart and BOM files'){
            }
      
            
            this.totalRows = this.result.returnvalue.length;                
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
        
   
   
       },
        
	 }

	};
</script>
<style>
 

  .nav_tabs {
    cursor: pointer;
    color: #16A2D7;
    font-size: 12px;
    border-bottom: 2px solid transparent;
    border-top: 2px solid transparent;
    position: relative;
    flex: 1 1;
    height: 60px;
    padding: 12px 24px;
    display: flex;
    flex-direction: row;
    cursor: pointer;
}
  .nav_tabs.is-tab-selected {
    border-bottom-color: #4EBBE4;
    border-top-color: #4EBBE4;
  }

  .nav_tabs__tab--disabled {
    cursor: not-allowed!important;
    opacity: .6;
    pointer-events: none; 
}

.nav_row_tabs {
 
  display: flex;
  border-top: 1px solid #D7DBDD;
  border-bottom: 1px solid #D7DBDD;
}
.navmenu{
  width: 80% !important;
}
@media screen and (max-width: 1024px) 
{
  #messagetab{
    width:110px !important;
  }
}
@media screen and (max-width: 320px) 
{
  .navmenu{
    width:80% !important;
  }
}
@media screen and (max-width: 414px) 
{
  .navmenu{
    width:90%  !important;
  }
}

</style>